// extracted by mini-css-extract-plugin
export var buttonContainer = "_8k-1";
export var fontSizeSelect = "_8k-3";
export var formatSelect = "_8k-2";
export var formats = "_8k-4";
export var hidden = "_8k-5";
export var icon = "_8k-6";
export var select = "_8k-0";